<template>
  <Modal
    v-model="_value"
    width="500"
    title="添加销售渠道"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="loginForm" :model="saleschannelinfo" :rules="rules" >
      <FormItem prop="name">
        <Input v-model="saleschannelinfo.name" placeholder="请输入销售渠道名称">
        </Input>
      </FormItem>
      <FormItem prop="telephoneNum">
        <Input v-model="saleschannelinfo.telephoneNum" placeholder="请输入联系电话">
        </Input>
      </FormItem>
      <FormItem prop="address">
        <Input v-model="saleschannelinfo.address" placeholder="请输入联系地址">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'AddSaleschannelInfoModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      nameRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '销售渠道名称不能为空', trigger: 'blur' }
          ]
        }
      },
    },
    data() {
      return {
        saleschannelinfo: {
          name:null,
          telephoneNum:null,
          address:null,
          lat:null,
          lng:null,
        }
      }
    },
    methods: {
      ...mapActions([
        'SalesChannelServ_AddObj'
      ]),
      onOk() {
        this.$Modal.confirm({
          title: '添加用户信息',
          content: '<p>是否确认添加用户信息</p>',
          onOk: () => {
            store.dispatch('SalesChannelServ_AddObj', {params: this.saleschannelinfo}).then(() => {
              this.$Message.success('添加销售渠道成功')
              this.$emit('on-success');
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail');
            })
          },
          onCancel: () => {
          }
        })
      },
      visibleChange(val) {
        if(val){
          this.saleschannelinfo.name = null
          this.saleschannelinfo.telephoneNum = null
          this.saleschannelinfo.address = null
          this.saleschannelinfo.lat = null
          this.saleschannelinfo.lng = null
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
